import * as styles from "./section.module.scss"

import React from "react"

const Section = ({ theme, className, style, hideContainer, children }) => {
  return (
    <div className={ [styles.section, styles[theme], className].join(' ') } style={ style }>
      { !hideContainer ? <div className="container">{ children }</div> : children }
    </div>
  )
}

export default Section